export default __webpack_public_path__ + "static/media/ss1.a26bf5a9.png";